import { Hexagram, Trigram, hexagramLines, trigramNameZh } from './meihua';

/* =====================================================================
 * 六十四卦名 —— 表键为「初爻→上爻」的阴阳串（1＝阳爻，0＝阴爻），
 * 与《梅花易数起卦排盘技术规范》附录 A 的 01 向量映射表一致。
 * 名称为标准写法：上卦象 + 下卦象 + 卦名（如 天地否、水雷屯）。
 * ===================================================================== */

export const GUA64: Record<string, string> = {
  '111111': '乾为天',
  '011111': '天风姤',
  '001111': '天山遁',
  '000111': '天地否',
  '000011': '风地观',
  '000001': '山地剥',
  '000101': '火地晋',
  '111101': '火天大有',
  '010010': '坎为水',
  '110010': '水泽节',
  '100010': '水雷屯',
  '101010': '水火既济',
  '101110': '泽火革',
  '101100': '雷火丰',
  '101000': '地火明夷',
  '010000': '地水师',
  '001001': '艮为山',
  '101001': '山火贲',
  '111001': '山天大畜',
  '110001': '山泽损',
  '110101': '火泽睽',
  '110111': '天泽履',
  '110011': '风泽中孚',
  '001011': '风山渐',
  '100100': '震为雷',
  '000100': '雷地豫',
  '010100': '雷水解',
  '011100': '雷风恒',
  '011000': '地风升',
  '011010': '水风井',
  '011110': '泽风大过',
  '100110': '泽雷随',
  '011011': '巽为风',
  '111011': '风天小畜',
  '101011': '风火家人',
  '100011': '风雷益',
  '100111': '天雷无妄',
  '100101': '火雷噬嗑',
  '100001': '山雷颐',
  '011001': '山风蛊',
  '101101': '离为火',
  '001101': '火山旅',
  '011101': '火风鼎',
  '010101': '火水未济',
  '010001': '山水蒙',
  '010011': '风水涣',
  '010111': '天水讼',
  '101111': '天火同人',
  '000000': '坤为地',
  '100000': '地雷复',
  '110000': '地泽临',
  '111000': '地天泰',
  '111100': '雷天大壮',
  '111110': '泽天夬',
  '111010': '水天需',
  '000010': '水地比',
  '110110': '兑为泽',
  '010110': '泽水困',
  '000110': '泽地萃',
  '001110': '泽山咸',
  '001010': '水山蹇',
  '001000': '地山谦',
  '001100': '雷山小过',
  '110100': '雷泽归妹'
};

/** 八卦的「象」：乾天、坤地、震雷、巽风、坎水、离火、艮山、兑泽 */
export function trigramImage(t: Trigram): string {
  switch (t) {
    case Trigram.qian: return '天';
    case Trigram.dui: return '泽';
    case Trigram.li: return '火';
    case Trigram.zhen: return '雷';
    case Trigram.xun: return '风';
    case Trigram.kan: return '水';
    case Trigram.gen: return '山';
    case Trigram.kun: return '地';
  }
}

/** 八卦卦符 ☰☱☲☳☴☵☶☷ */
export function trigramSymbol(t: Trigram): string {
  switch (t) {
    case Trigram.qian: return '☰';
    case Trigram.dui: return '☱';
    case Trigram.li: return '☲';
    case Trigram.zhen: return '☳';
    case Trigram.xun: return '☴';
    case Trigram.kan: return '☵';
    case Trigram.gen: return '☶';
    case Trigram.kun: return '☷';
  }
}

/** 六爻阴阳串（初爻→上爻，1＝阳） */
export function hexagramVector(h: Hexagram): string {
  return hexagramLines(h).map((l) => (l === 'yang' ? '1' : '0')).join('');
}

/** 标准卦名，如「天地否」；表外（不应发生）退回「上X下Y」写法 */
export function hexagramName(h: Hexagram): string {
  const name = GUA64[hexagramVector(h)];
  if (name) return name;
  return `上${trigramNameZh(h.upper)}下${trigramNameZh(h.lower)}`;
}

/** 八宫名（用于「乾宫」这类表述）：取上卦所属的八宫 */
export function palaceName(t: Trigram): string {
  return trigramNameZh(t) + '宫';
}
